import { FaPlus } from "react-icons/fa";
import { IconButton } from "./IconButton";
import { SearchInput } from "./SearchInput";

export const ReportsToolbar = ({searchTerm,setSearchTerm,userData,usersTable}) => (
    <div className=" serach toolbar-container">
             <div className="col-2 ms-3 d-flex justify-content-start">
                <SearchInput value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
             </div>
             {userData?.userAdmin === 'Y' && (<div className="col-1 me-3 d-flex justify-content-end">
                  <IconButton label="Users" onClick={usersTable}  className="btn-click"/>
             </div>)}           
        </div>
);
export const UsersToolbar = ({searchTerm,setSearchTerm,onAdd}) => (
    <div className="toolbar-container">
             <div className="col-2 ms-3 d-flex justify-content-start">
                <SearchInput value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
             </div>
             <div className="add-item col-1.5 me-3 d-flex justify-content-end">
                  <IconButton icon={<FaPlus />} label="Add New" onClick={onAdd}  className="btn-click"/>
             </div>             
        </div>
);
